<template>
  <div />
</template>

<script setup>
import { ref, computed, watch, getCurrentInstance } from 'vue';
import { storeToRefs } from 'pinia';
import { usePhaseStore } from '@/store/pinia/phase';
import { useUsersStore } from '@/store/pinia/users';
import { useReady } from '@/composables/useReady';
const phaseStore = usePhaseStore();
const usersStore = useUsersStore();
const { finishedFirstAvatars } = useReady();
const { $sfx } = getCurrentInstance().appContext.config.globalProperties;

const { iAmSpeaking } = storeToRefs(usersStore);
const { currentPhase } = storeToRefs(phaseStore);
const dingedThisPhase = ref(false);

const hasDing = computed(() => {
  return ['checkIn', 'checkOut'].includes(currentPhase.value);
});

const shouldDing = computed(() => {
  return hasDing.value && iAmSpeaking.value && finishedFirstAvatars.value && !dingedThisPhase.value;
});

watch(shouldDing, (nv, ov) => {
  if (nv && !ov) {
    dingedThisPhase.value = true;
    $sfx('ding');
  }
});

watch(currentPhase, () => {
  dingedThisPhase.value = false;
});
</script>
